import { values } from './_helpers'

const _enum = {
  white: 0,
  red: 1,
  rose: 2,
  orange: 3
}

const grapeType = { ..._enum, name: 'grapeType', values: values(_enum) }

export {
  grapeType
}
